import { useEffect } from 'react';
import { Box, Container, Typography, Stack, Link } from '@mui/material';

export default function BookMeetingPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Box sx={{ bgcolor: '#fff', minHeight: '100vh', py: { xs: 4, md: 8 } }}>
      <Container maxWidth="lg">
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={6} alignItems="flex-start" justifyContent="center">
          {/* Left column: Info */}
          <Box sx={{ flex: 1, pr: { md: 6 }, mb: { xs: 4, md: 0 } }}>
            <Typography variant="h2" fontWeight={900} sx={{ fontSize: { xs: 32, md: 48 }, mb: 3, lineHeight: 1.1 }}>
              Book a<br />Meeting
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary', fontSize: { xs: 16, md: 18 } }}>
              We're here to help! Fill out the form or email us to book a meeting. Our team will ensure you have the best experience—whether you have a question about your order or need expert advice.
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary', fontSize: { xs: 15, md: 16 } }}>
              We respond personally to every inquiry. Please allow up to 24 hours for a reply during business hours (Monday to Friday, 9am–5pm EST).
            </Typography>
            <Stack spacing={2} sx={{ mt: 4 }}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Link href="mailto:hello@impactquill.com" underline="hover" sx={{ fontSize: 16, color: 'inherit' }}>
                  hello@impactquill.com
                </Link>
              </Stack>
            </Stack>
          </Box>
          {/* Right column: Calendly Widget */}
          <Box sx={{ flex: 1, width: '100%' }}>
            <div
              className="calendly-inline-widget"
              data-url="https://calendly.com/impactquill/30min?ide_landing_page_details=1&hide_gdpr_banner=1"
              style={{ minWidth: 320, height: 700 }}
            />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
} 